import CTAScreen from "./components/CTAScreen";
import Fallback from "./components/Fallback";
import SafeCountdown from "./components/SafeCountdown";
import { useVideoAd } from "./presentation/VideoAdContext";
import Player from "./video";

export const App = () => {
  const { state } = useVideoAd();

  if (state.phase === "finished") return null;

  return (
    <>
      {state.phase === "fallback" ? <Fallback /> : null}
      {state.phase !== "fallback" ? (
        <CTAScreen>
          <Player />
        </CTAScreen>
      ) : null}
      {state.phase !== "loading" && state.phase !== "cta" ? (
        <SafeCountdown />
      ) : null}
    </>
  );
};

export default App;
